import { render } from "./RegisterTemplate.vue?vue&type=template&id=f0042870&scoped=true"
import script from "./RegisterTemplate.vue?vue&type=script&lang=js"
export * from "./RegisterTemplate.vue?vue&type=script&lang=js"

import "./RegisterTemplate.vue?vue&type=style&index=0&id=f0042870&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0042870"]])

export default __exports__